import React, { useEffect, useRef, useState } from "react";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import NetaqInput from "../components/NetaqInput";
// import Select from "react-select";
import ActionButton from "../components/ActionButton";
import { useLocation, useNavigate } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import {
    FetchCreateOrEditGeneticDisorderTestingthunk,
    FetchGetServiceDefinitionByIdthunk,
    FetchGetServicesRequestByIdthunk,
} from "../Redux/ServicesRequests/ServicesRequestsAction";
import {
    resetGetServicesRequestByIdData,
    resetToasterMessageServicesRequests,
} from "../Redux/ServicesRequests/ServicesRequestsSlice";
import { FetchSubOwnerProfilesByIdthunk } from "../Redux/ShowEntry/ShowEntryAction";
import EahsForm from "../components/EahsForm";
import { FetchOwnerHorsesDropDownthunk } from "../Redux/OwnerProfile/OwnerProfileAction";
import PillBtn from "../components/PillBtn";
import DraftBtn from "../components/servicesButtons/DraftBtn";
import ApproveAndPayLaterBtn from "../components/servicesButtons/ApproveAndPayLaterBtn";
import SubmitAndPay from "../components/servicesButtons/SubmitAndPay";
import SubmitServiceBtn from "../components/servicesButtons/SubmitServiceBtn";

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { FormHelperText, Typography } from "@mui/material";
import { eFormButtonsContainer, eformInput, eformTerms, serviceRequestHeadContainer, serviceRequestTitle, userDropDown } from "../common/cssclasses";
import NewActionButton from "../components/ActionButtons/NewActionButton";

export default function GeneticDisorderTesting() {
    //env
    const UMBRACOURL = process.env.REACT_APP_UMBRACO;
    //const UMBRACOURL = process.env.REACT_APP_Local_UMBRACO;
    const BaseURL = process.env.REACT_APP_BASE_URL;

    //selector
    const { ownerHorsesDropDownData } = useSelector(
        (state) => state.ownerProfileSlice
    );

    const { currentLanguage } = useSelector((state) => state.studBookSlice);

    const {
        toasterMessageServicesRequests,
        servicesRequestsLoading,
        getServicesRequestByIdData,
        getServiceDefinitionByIdData,
        geneticDisorderTestingData,
    } = useSelector((state) => state.servicesRequestsSlice);

    const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
    const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];

    const dispatch = useDispatch();

    const { translate } = useTranslate();

    const navigate = useNavigate();

    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);

    const serviceId = searchParams.has("serviceId")
        ? searchParams.get("serviceId")
        : null;

    const id = searchParams.has("id") ? searchParams.get("id") : null;

    const action = searchParams.has("action") ? searchParams.get("action") : null;
    const ownerId = searchParams.has("ownerId") ? searchParams.get("ownerId") : null;

    //state
    const [profile, setProfile] = useState({
        label:
            !!userProfile &&
            userProfile?.ownerRegisterNo +
            " - " +
            userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
        value: localStorage.getItem("EAHSUserID"),
    });

    const [formModel, setFormModel] = useState({
        id: null,
        eventName: "",
        comment: "",
        referenceNumber: "",
        requestsType: "",
        paymentStatus: "",

        oldHorsesListCount: 0,
        horses: [],
        horse: "",
        horseDrop: {
            label: translate("web.horse", "Horse"),
            value: null,
        },
        isCA: false,
        isLFS: false,
        isSCID: false,
        isOther: false,
        other: "",

        ownerComment: "",
    });

    const [errorHorse, setErrorHorse] = useState(false);
    const [errorTestType, setErrorTestType] = useState(false);
    const [errorOther, setErrorOther] = useState(false);

    //use ref
    const horseRef = useRef(null);
    const otherRef = useRef(null);

    const _isOnlinePayment = useRef("");
    const _status = useRef("");
    const [checkedItems, setCheckedItems] = useState({});

    // const [checkedItems, setCheckedItems] = useState({
    //     option1: false,
    // });

    const subAccountId = localStorage.getItem("currentSubAccountId");

    const customStyles = {
        control: (base) => ({
            ...base,
            height: 50,
            minHeight: 50,
        }),
    };

    //function   

    const handleFormChange = (e, input) => {
        if (input === "horse") {
            setFormModel({
                ...formModel,
                horse: e.value,
                horseDrop: e,
            });
        }
        else if (input === "testType") {
            setFormModel({
                ...formModel,
                other: e.target.name === "isOther" ? "" : formModel.other,
                [e.target.name]: e.target.checked,
            });
        }
        else {
            setFormModel({
                ...formModel,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handelAddHorse = () => {
        let valid = true;

        if (formModel.horse === "") {
            setErrorHorse(true);
            valid = false;

            horseRef?.current?.focus();
            return;
        }
        else {
            setErrorHorse(false);
        }

        if (
            !formModel.isCA && !formModel.isLFS && !formModel.isSCID && !formModel.isOther
        ) {
            setErrorTestType(true);
            valid = false;
        }
        else {
            setErrorTestType(false);
        }

        if (
            formModel.isOther && formModel.other.trim() === ""
        ) {
            setErrorOther(true);
            valid = false;

            otherRef?.current?.focus();
            return;
        }
        else {
            setErrorOther(false);
        }

        const horseExists = formModel.horses.some(horse => horse.horseId === formModel.horse);

        if (horseExists) {
            toast.error(
                translate("web.horseExist", "Horse Exist")
            );

            valid = false;

            return;
        }

        if (valid) {

            let newItem = {
                id: null,
                horseId: formModel.horse,
                horseName: ownerHorsesDropDownData.filter(q => q.id == formModel.horse)[0]?.registerNumber + " - " + ownerHorsesDropDownData.filter(q => q.id == formModel.horse)[0]?.name,
                isCA: formModel.isCA,
                isLFS: formModel.isLFS,
                isSCID: formModel.isSCID,
                other: formModel.other,
            };

            setFormModel((prev) => {
                setTypes([selectPlaceHolder]);
                return ({
                    ...formModel,
                    horses: [...formModel.horses, newItem],
                    horse: "",
                    horseDrop: {
                        label: translate("web.horse", "Horse"),
                        value: null,
                    },
                    isCA: false,
                    isLFS: false,
                    isSCID: false,
                    isOther: false,
                    other: "",
                })
            });
        }
    }

    const removeHorse = (indexToRemove) => {
        setFormModel({
            ...formModel,
            horses: formModel.horses.filter((_, index) => index !== indexToRemove)
        });
    };

    const validInputs = () => {
        let valid = true;

        if (
            formModel.horses.length === 0
        ) {
            toast.error(
                translate("web.pleaseAddHorseToList", "Please Add Horse To List")
            );
            valid = false;
        }

        if (
            formModel.eventName === "SentBack" && formModel.horses.length < formModel.oldHorsesListCount
        ) {
            toast.error(
                translate("web.pleaseAddHorseToList", "Please Add Horse To List")
            );
            valid = false;
        }

        //term
        if (Object.values(checkedItems).length > 0) {  // Optional safe check
            const allTermsChecked = Object.values(checkedItems).every((isChecked) => isChecked);

            if (!allTermsChecked && action == null) {
                toast.error(
                    translate("web.pleaseCheckAllTerms", "Please Check All Terms")
                );
                valid = false;
            }
        }

        // if (
        //     !checkedItems.option1
        // ) {
        //     toast.error(
        //         translate("web.pleaseCheckTerm", "Please Check Term")
        //     );
        //     valid = false;
        // }

        return valid;
    }

    const handelFormSubmit = (status, isOnlinePayment, buttonAction = 'Draft') => {
        if (getServiceDefinitionByIdData.serviceFees > 0 && formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice" && formModel.eventName !== "SentBack") {
            const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${id}`;

            const encodeURI = encodeURIComponent(returnUrl);

            window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id}&paymentType=23&userId=${localStorage.getItem("EAHSUserID")}&returnUrl=${encodeURI}&isOnline=${isOnlinePayment}&lang=${currentLanguage}`;
        }
        else {
            if (
                validInputs()
            ) {
                _isOnlinePayment.current = isOnlinePayment;
                _status.current = status;

                let params = {
                    id: id,
                    ownerId: getUserID(),
                    status: status,
                    horses: formModel.horses,
                    ownerComment: formModel.ownerComment,
                    buttonAction: buttonAction
                };

                dispatch(FetchCreateOrEditGeneticDisorderTestingthunk(params));
            }
            else {
                toast.error(
                    translate("web.completeTheRequiredData", "Complete The Required Data")
                );
            }
        }
    };

    const handelSelectedAccountChange = async (element) => {
        let params = {
            ownerId: element.value,
            skip: 0,
            take: 1000,
            langauge: currentLanguage,
            horseTypeFilter: "1",
            searchValue: "",
            sortBy: "-1",
            serviceDefinitionId: serviceId,
        };
        dispatch(FetchOwnerHorsesDropDownthunk(params));

        setProfile(element);

        setFormModel({
            ...formModel,
            horses: [],
            horse: "",
            horseDrop: {
                label: translate("web.horse", "Horse"),
                value: null,
            },
            isCA: false,
            isLFS: false,
            isSCID: false,
            isOther: false,
            other: "",
        });
    };

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;

        setCheckedItems((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    function CheckIfAgentHasPermission() {
        const AgentHasPermission = userProfile.subAccounts
            .filter((x) => x.value == subAccountId)[0]
            .ownersPermissionsList.some(
                (x) =>
                    x.permissionName === "GeneticDisorderTesting" || x.permissionName === "All"
            );

        return AgentHasPermission;
    }

    // const getUserID = () => {
    //     const userID =
    //         !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;

    //     return userID;
    // };
    const getUserID = () => {
        let userID =
            !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
        if ((action == null || action === "edit") == false) {
            userID = subAccountId;
        }
        return userID;
    };

    const getSelectedAccountName = () => {
        const selectAccount = userProfile.subAccounts.filter(
            (x) => x.value == subAccountId
        );

        if (selectAccount.length > 0) {
            return selectAccount[0];
        }
        else {
            return false;
        }
    };

    const dismissAll = () => toast.dismiss();

    const handelDisabledAddHorse = () => {
        if (
            action === "view"
            || (action === "approve" && formModel.eventName !== "SentBack")
        ) {
            return true;
        }
        else {
            if (formModel.eventName === "SentBack" && formModel.horses.length === formModel.oldHorsesListCount) {
                return true;
            }
            else {
                return false;
            }
        }
    };

    const handelDisabledButton = () => {
        if (
            action === "view"
            || (action === "approve" && formModel.eventName !== "SentBack")
        ) {
            return true;
        }
        else {
            return false;
        }
    };

    //Effect
    useEffect(() => {
        if (id != null) {
            let params = {
                language: currentLanguage,
                id: id,
                ownerId: ownerId,

            };

            dispatch(FetchGetServicesRequestByIdthunk(params));
        }

        return () => {
            dispatch(resetGetServicesRequestByIdData());
        };
    }, []);

    useEffect(() => {
        if (!!userProfile && userProfile?.haveProfileSignture != true) {
            toast.error(
                translate(
                    "web.completeOwnerProfileData",
                    "Please complete the personal data of the profile."
                )
            );

            setTimeout(() => {
                navigate("/profile");
            }, 3000);
        }

        if (!!userProfile && userProfile?.accountType === "Agent") {
            if (userProfile.id == subAccountId) {
                navigate("/403-Not-Authrized");
            }

            if (!CheckIfAgentHasPermission()) {
                navigate("/403-Not-Authrized");
            }
        }

        let params = {
            ownerId: getUserID(),
            skip: 0,
            take: 1000,
            langauge: currentLanguage,
            horseTypeFilter: "1",
            searchValue: "",
            sortBy: "-1",
            serviceDefinitionId: serviceId,
        };
        dispatch(FetchOwnerHorsesDropDownthunk(params));

        let subOwnerProfilesParams = {
            id: getUserID(),
            langauge: currentLanguage,
        };
        dispatch(FetchSubOwnerProfilesByIdthunk(subOwnerProfilesParams));

        dispatch(FetchGetServiceDefinitionByIdthunk(serviceId));
    }, [currentLanguage]);

    useEffect(() => {
        if (getServicesRequestByIdData != null &&
            Object.keys(getServicesRequestByIdData).length > 0 && (getServicesRequestByIdData.serviceDefinitionId == serviceId)
        ) {
            setFormModel({
                ...formModel,
                eventName: getServicesRequestByIdData.eventName,
                comment: getServicesRequestByIdData.comment,
                requestsType: getServicesRequestByIdData.requestsType,
                paymentStatus: getServicesRequestByIdData.paymentStatus,
                referenceNumber: " - " + getServicesRequestByIdData.referenceNumber,

                oldHorsesListCount: getServicesRequestByIdData.geneticDisorderTesting.geneticDisorderTestingDetailsDto?.length,
                horses: getServicesRequestByIdData.geneticDisorderTesting.geneticDisorderTestingDetailsDto.map((q) => ({
                    id: q.id,
                    horseId: q.horseId,
                    horseName: q.horseName,
                    isCA: q.isCA,
                    isLFS: q.isLFS,
                    isSCID: q.isSCID,
                    other: q.other,
                })),
            });

            //another owner
            if (
                getServicesRequestByIdData.geneticDisorderTesting.ownerId !==
                getServicesRequestByIdData.geneticDisorderTesting.createdBy &&
                subOwnerProfilesByIdData.length > 0 &&
                getServicesRequestByIdData.requestsType !== "BackOffice"
            ) {
                let params = {
                    ownerId: getServicesRequestByIdData.geneticDisorderTesting.ownerId,
                    skip: 0,
                    take: 1000,
                    langauge: currentLanguage,
                    horseTypeFilter: "1",
                    searchValue: "",
                    sortBy: "-1",
                    serviceDefinitionId: serviceId,
                };
                dispatch(FetchOwnerHorsesDropDownthunk(params));

                //update profile
                setProfile({
                    label:
                        subOwnerProfilesByIdData.filter(
                            (item) =>
                                item.value ==
                                getServicesRequestByIdData.geneticDisorderTesting.ownerId
                        )[0].registerNo +
                        " - " +
                        subOwnerProfilesByIdData.filter(
                            (item) =>
                                item.value ==
                                getServicesRequestByIdData.geneticDisorderTesting.ownerId
                        )[0][`text${currentLanguage === "en" ? "" : "Ar"}`],
                    value: subOwnerProfilesByIdData.filter(
                        (item) =>
                            item.value == getServicesRequestByIdData.geneticDisorderTesting.ownerId
                    )[0].value,
                });
            }

            //options
            // setCheckedItems({
            //     option1: true,
            // });
        }
    }, [
        getServicesRequestByIdData,
    ]);

    useEffect(() => {
        if (
            toasterMessageServicesRequests != null &&
            toasterMessageServicesRequests === "save"
        ) {
            if (_isOnlinePayment.current !== "") {
                toast.success(
                    translate(
                        "web.yourRequestHasSubmittedSuccessfully",
                        "Your Request Has Submitted Successfully"
                    )
                );
            } else {
                toast.success(
                    translate("web.dataSavedSuccessfully", "Data Saved Successfully")
                );
            }

            dispatch(resetToasterMessageServicesRequests());

            setTimeout(() => {
                if (_isOnlinePayment.current !== "") {
                    const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${geneticDisorderTestingData.id}`;

                    const encodeURI = encodeURIComponent(returnUrl);

                    window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${geneticDisorderTestingData.id}&paymentType=23&userId=${localStorage.getItem(
                        "EAHSUserID"
                    )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;
                } else {
                    if (_status.current === "Submit" && formModel.eventName !== "SentBack") {
                        navigate(`/profile?activeTab=${"e_services"}&serviceId=${geneticDisorderTestingData.id}`);
                    }
                    else {
                        navigate(`/profile?activeTab=${"e_services"}`);
                    }
                }
            }, 1000);
        }

        //error
        else if (toasterMessageServicesRequests != null && toasterMessageServicesRequests !== "save") {
            if (toasterMessageServicesRequests !== "errorServiceDetails") {

                toast.error(
                    translate(toasterMessageServicesRequests, toasterMessageServicesRequests)
                );

                dispatch(resetToasterMessageServicesRequests());
            }

            else if (toasterMessageServicesRequests === "errorServiceDetails") {
                toast.error(
                    translate("web.createServiceRequestFailed", "Service Request Failed")
                );

                dispatch(resetToasterMessageServicesRequests());

                setTimeout(() => {
                    navigate(`/profile?activeTab=${"e_services"}`);
                }, 1000);
            }
        }
    }, [toasterMessageServicesRequests]);

    useEffect(() => {
        if (getServiceDefinitionByIdData?.termsList) {
            const initialState = {};
            getServiceDefinitionByIdData.termsList.forEach((_, index) => {
                initialState[`option${index + 1}`] = false;
            });
            setCheckedItems(initialState);
        }
    }, [getServiceDefinitionByIdData?.termsList]);

    //consoles
    console.log(formModel)

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        disableScrollLock: true,
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const hasExistingOther = Boolean(
        formModel.horses?.some((h) => (!!h.other && h.other.trim() !== "") || h.isOther === true) ||
        getServicesRequestByIdData?.geneticDisorderTesting?.geneticDisorderTestingDetailsDto?.some(
            (q) => (!!q.other && q.other.trim() !== "") || q.isOther === true
        )
    );
    const showOther = hasExistingOther;

    var names = [
        {
            name: 'isCA',
            text: "(CA) " + translate("web.cerebellarAbiotrophy", "Cerebellar Abiotrophy"),
        },
        {
            name: 'isSCID',
            text: "(SCID) " + translate("web.servereCombinedImmunodeficiency", "Servere Combined Immunodeficiency"),
        },
        {
            name: 'isLFS',
            text: "(LFS) " + translate("web.lavenderFoalSyndrome", "Lavender Foal Syndrome"),
        },
        ...(hasExistingOther
            ? [
                {
                    name: 'isOther',
                    text: translate("web.other", "Other"),
                },
            ]
            : []),
    ];
    const selectPlaceHolder = currentLanguage == 'en' ? 'Select Type' : 'اختر النوع'
    const [types, setTypes] = useState([selectPlaceHolder]);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;

        setFormModel((prev) => {
            return ({
                ...formModel,
                isCA: value?.includes('isCA'),
                isLFS: value?.includes('isLFS'),
                isOther: value?.includes('isOther'),
                isSCID: value?.includes('isSCID')
            })
        });

        const index = value.indexOf(selectPlaceHolder);
        if (index > -1) { // only splice array when item is found
            value.splice(index, 1); // 2nd parameter means remove one item only
        }
        if (value?.length == 0) {
            setTypes([selectPlaceHolder]);
        } else {
            setTypes(
                // On autofill we get a stringified value.
                typeof value === 'string' ? value.split(',') : value,
            );
        }
    };

    return (
        <>
            {/* loading div */}
            <div
                className={`page-overlay text-center ${servicesRequestsLoading
                    ? "classdisplay"
                    : "classnotdisplay"
                    }`}
            >
                <div className="loaderDiv">
                    <Loader />
                </div>
            </div>

            {/* toast */}
            <ToastContainer
                position="top-right"
                onClick={dismissAll}
                theme="colored"
                autoClose={5000}
            />

            {/* content page */}
            <div className={serviceRequestHeadContainer}>
                <h2 className={serviceRequestTitle}>
                    {currentLanguage === "en"
                        ? getServiceDefinitionByIdData.nameEn
                        : getServiceDefinitionByIdData.nameAr} {formModel.referenceNumber}{" "}
                </h2>

                {/* Selected Account */}
                {subOwnerProfilesByIdData.length > 0 &&
                    (action == null || action === "edit") &&
                    (
                        <div className={userDropDown}>
                            {!!userProfile && userProfile?.accountType !== "Agent" ? (
                                <>
                                    <NetaqInput
                                        label={translate("web.selectedAccount", "Selected Account")}
                                        name="selectAccount"
                                        type="select"
                                        listSelect={[
                                            {
                                                label:
                                                    userProfile?.ownerRegisterNo +
                                                    " - " +
                                                    userProfile[
                                                    `fullName${currentLanguage === "en" ? "" : "Ar"}`
                                                    ],
                                                value: localStorage.getItem("EAHSUserID"),
                                            },
                                            ...(!!subOwnerProfilesByIdData &&
                                                !!subOwnerProfilesByIdData.length > 0 &&
                                                subOwnerProfilesByIdData.map((a) => ({
                                                    label:
                                                        a?.registerNo +
                                                        " - " +
                                                        a[`text${currentLanguage === "en" ? "" : "Ar"}`],
                                                    value: a.value,
                                                }))),
                                        ]}
                                        value={profile}
                                        onChange={(e) => {
                                            handelSelectedAccountChange(e);
                                        }}
                                        placeholder={localStorage.getItem("EAHSUserFullName")}
                                    />
                                </>
                            ) : (
                                <label className="capatalize_text">
                                    {getSelectedAccountName()?.registerNo +
                                        " - " +
                                        getSelectedAccountName()[
                                        `text${currentLanguage === "en" ? "" : "Ar"}`
                                        ]}
                                </label>
                            )}
                        </div>
                    )}
            </div>
            <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.horsesLists", "horses Lists")}>

                <div className={eformInput}>
                    <NetaqInput
                        label={translate("web.horse", "Horse")}
                        type='select'
                        listSelect={[
                            {
                                label: translate("web.horse", "Horse"),
                                text: translate("web.horse", "Horse"),
                                value: "",
                            },
                            ...(!!ownerHorsesDropDownData &&
                                ownerHorsesDropDownData.map((a) => ({
                                    label: a.registerNumber + " - " + a.name,
                                    text: a.registerNumber + " - " + a.name,
                                    value: a.id,
                                }))),
                        ]}
                        value={formModel.horseDrop}
                        onChange={(e) => handleFormChange(e, "horse")}
                        placeholder={translate("web.horse", "Horse")}
                        name={"horse"}
                        isSearchable
                        noOptionsMessage={() =>
                            translate("web.noOptions", "No Options")
                        }
                        autoFocus={true}
                        key={"horse"}
                        ref={horseRef}
                        isDisabled={handelDisabledButton()}
                    />

                    {errorHorse && (
                        <p style={{ color: "red" }}>
                            {translate("web.requiredField", "Required Field")}
                        </p>
                    )}
                </div>
                <div className={eformInput}>
                    <label>
                        {translate("web.testType", "Test Type")}
                        <i className=" colorred mx-1"> *</i>
                    </label>
                    <FormControl className="w-100" sx={{ maxHeight: 38, lineHeight: 30 }}>
                        {/* {errorTestType && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )} */}
                        <Select
                            labelId="demo-multiple-checkbox-label"
                            id="demo-multiple-checkbox"
                            multiple
                            sx={{ maxHeight: 38 }}
                            value={types}
                            onChange={handleChange}
                            input={<OutlinedInput />}
                            required={true}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    // Return the placeholder text.
                                    // Optionally wrap in Typography or span for styling
                                    return <Typography sx={{ color: "text.secondary" }}>Your Placeholder</Typography>;
                                    // Or simply: return "Your Placeholder";
                                    // Or use an em tag which often gets default placeholder styling: return <em>Your Placeholder</em>;
                                } else {
                                    return selected.join(', ');
                                }

                            }}
                            MenuProps={MenuProps}
                        >
                            {names.map((x) => (
                                <MenuItem key={x?.text} value={x?.name}>
                                    <Checkbox checked={formModel[x?.name]} />
                                    <ListItemText primary={x?.text} />
                                </MenuItem>
                            ))}
                        </Select>
                        {errorTestType && <FormHelperText className={'text-start p0 w-100'} sx={{ fontSize: 16, color: 'red', paddingRight: "unset !important", paddingLeft: 'unset !important' }} >{translate("web.requiredField", "Required Field")}</FormHelperText>}
                    </FormControl>
                    {false &&
                        <>
                            <div className=" col-sm-3 col-6 mb-1">
                                <NetaqInput
                                    type={"checkbox"}
                                    label={"(CA) " + translate("web.cerebellarAbiotrophy", "Cerebellar Abiotrophy")}
                                    name="isCA"
                                    checked={formModel.isCA}
                                    onChange={(e) => handleFormChange(e, "testType")}
                                    disabled={handelDisabledButton()}
                                />

                            </div>
                            <div className=" col-sm-3 col-6 mb-1">
                                <NetaqInput
                                    type={"checkbox"}
                                    label={"(LFS) " + translate("web.lavenderFoalSyndrome", "Lavender Foal Syndrome")}
                                    name="isLFS"
                                    checked={formModel.isLFS}
                                    onChange={(e) => handleFormChange(e, "testType")}
                                    disabled={handelDisabledButton()}
                                />
                            </div>
                            <div className=" col-sm-3 col-6 mb-1">
                                <NetaqInput
                                    type={"checkbox"}
                                    label={"(SCID) " + translate("web.servereCombinedImmunodeficiency", "Servere Combined Immunodeficiency")}
                                    name="isSCID"
                                    checked={formModel.isSCID}
                                    onChange={(e) => handleFormChange(e, "testType")}
                                    disabled={handelDisabledButton()}
                                />
                            </div>
                            <div className=" col-sm-3 col-6 mb-1">
                                <NetaqInput
                                    type={"checkbox"}
                                    label={translate("web.other", "Other")}
                                    name="isOther"
                                    checked={formModel.isOther}
                                    onChange={(e) => handleFormChange(e, "testType")}
                                    disabled={handelDisabledButton()}
                                />
                            </div>
                        </>
                    }
                </div>

                {formModel.isOther && (
                    <div className="row px-0 mx-0">
                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.other", "Other")}
                                name={"other"}
                                type={"text"}
                                onChange={handleFormChange}
                                value={formModel.other}
                                required={true}
                                ref={otherRef}
                                disabled={handelDisabledButton()}
                            />
                            {errorOther && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>
                    </div>
                )}

                <div className="col-sm-2 col-6  ms-auto mb-1">
                    <NewActionButton
                        classNames="btn-dark "
                        text={
                            <>
                                <i class="fa-solid fa-circle-plus me-2"></i>
                                {translate("web.addToList", "Add To List")}
                            </>
                        }
                        onClick={handelAddHorse}
                        disabled={handelDisabledAddHorse()}
                    />
                </div>


                <div className="scrolableTable mb-1">
                    <table className="table table-striped table-bordered rtl horseResultTable">
                        <thead className="theadHorseSelect">
                            <tr>
                                <th rowSpan={2} className="text-center">
                                    {translate("web.horseName", "Horse Name")}
                                </th>
                                <th colSpan={showOther ? 4 : 3} className="text-center">
                                    {translate("web.testType", "Test Type")}
                                </th>
                                <th rowSpan={2} className="text-center">
                                    {translate("web.action", "Action")}
                                </th>
                            </tr>
                            <tr>
                                <th className="text-center">
                                    (CA)
                                </th>
                                <th className="text-center">
                                    (LFS)
                                </th>
                                <th className="text-center">
                                    (SCID)
                                </th>
                                {showOther && (
                                    <th className="text-center">
                                        {translate("web.other", "Other")}
                                    </th>
                                )}
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            {formModel.horses?.length > 0 && (
                                formModel.horses.map((item, index) => (
                                    <tr key={index}>
                                        <td> {item.horseName}</td>
                                        <td>
                                            <NetaqInput
                                                type={"checkbox"}
                                                label={""}
                                                name={`isSCID${item}`}
                                                checked={item.isCA}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <NetaqInput
                                                type={"checkbox"}
                                                label={""}
                                                name={`isLFS${item}`}
                                                checked={item.isLFS}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <NetaqInput
                                                type={"checkbox"}
                                                label={""}
                                                name={`isSCID${item}`}
                                                checked={item.isSCID}
                                                disabled={true}
                                            />
                                        </td>
                                        {showOther && <td>{item.other}</td>}
                                        <td>
                                            <NewActionButton
                                                classNames={"btn-danger"}
                                                text={
                                                    <>
                                                        <i className=" fa-solid fa-circle-xmark me-2"></i>
                                                        {translate("web.delete", "Delete")}
                                                    </>
                                                }
                                                onClick={() => removeHorse(index)}
                                                disabled={handelDisabledButton()}
                                            />
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* <div className="col-md-4 col-sm-12 mt-3">
                        <label>(CA): {translate("web.cerebellarAbiotrophy", "Cerebellar Abiotrophy")}</label>
                    </div>
                    <div className="col-md-4 col-sm-12 mt-3">
                        <label>(LFS): {translate("web.lavenderFoalSyndrome", "Lavender Foal Syndrome")}</label>
                    </div>
                    <div className="col-md-4 col-sm-12 mt-3">
                        <label>(SCID): {translate("web.servereCombinedImmunodeficiency", "Servere Combined Immunodeficiency")}</label>
                    </div> */}
            </EahsForm>

            {/* Comments */}
            {(!!formModel.comment || !!formModel.ownerComment) && (
                <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.comments", "Comments")}>
                    {!!formModel.comment && (
                        // eahs Comment
                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.eahsComments", "EAHS Comments")}
                                name={"adminComment"}
                                type={"textarea"}
                                maxchars={1150}
                                value={formModel.comment}
                                disabled={true}
                            />
                        </div>
                    )}

                    {(!!formModel.ownerComment || formModel.eventName === "SentBack") && (
                        // owner Comment
                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.ownerComment", "Owner Comment")}
                                name={"ownerComment"}
                                type={"textarea"}
                                maxchars={1150}
                                value={formModel.ownerComment}
                                onChange={handleFormChange}
                                disabled={formModel.eventName !== "SentBack" ? true : false}
                            />
                        </div>
                    )}
                </EahsForm>
            )}

            <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
                {getServiceDefinitionByIdData?.termsList?.map((item, index) => {
                    return (
                        <div className={eformTerms} key={index}>
                            <NetaqInput
                                type={"checkbox"}
                                label={item}
                                name={`option${index + 1}`}
                                checked={checkedItems[`option${index + 1}`] || action != null}
                                onChange={handleCheckboxChange}
                                disabled={formModel.eventName !== ""}
                            />
                        </div>
                    );
                })}
            </EahsForm>

            {/* <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
                <div className={eformTerms}>
                    <NetaqInput
                        type={"checkbox"}
                        label={translate(
                            "web.ServiceGeneralNote",
                            "Service General Note"
                        )}
                        name="option1"
                        checked={checkedItems.option1}
                        onChange={handleCheckboxChange}
                        disabled={formModel.eventName === "" ? false : true}
                    />
                </div>
            </EahsForm> */}

            {/* buttons*/}
            <div className={eFormButtonsContainer}>
                {/* draft btn */}
                {(formModel.eventName === "" || formModel.eventName === "Draft") && (
                    <DraftBtn
                        onClick={() => handelFormSubmit("Draft", "", 'Draft')}
                        isDisabled={
                            formModel.eventName === "" ||
                                formModel.eventName === "Draft"
                                ? false
                                : true
                        }
                    />

                )}
                {/* ${translate("web.submitAndPayLater", "Submit And Pay Later")} */}

                {/* pay btn */}
                {userProfile?.participateWithoutPayment === true && formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                    <ApproveAndPayLaterBtn
                        isApprove={false}
                        selectedAccountId={profile?.value}

                        onClick={() =>
                            handelFormSubmit("Draft", "no", 'Pay')
                        }
                        isDisabled={
                            formModel.eventName === "SentBack"
                                ? true
                                : false
                        } />
                )}

                {formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                    <SubmitAndPay
                        selectedAccountId={profile?.value}
                        onClick={() =>
                            handelFormSubmit("Draft", "yes", 'Pay')
                        }
                        isDisabled={
                            formModel.eventName === "SentBack"
                                ? true
                                : false
                        }
                    />

                )}

                {/* submit btn */}
                {((getServiceDefinitionByIdData.serviceFees === 0 || formModel.eventName === "SentBack") && action !== "view") && (
                    <SubmitServiceBtn
                        onClick={() =>
                            handelFormSubmit("Submit", "", 'Submit')
                        }
                        isDisabled={
                            getServiceDefinitionByIdData.serviceFees === 0 || formModel.eventName === "SentBack"
                                ? false
                                : true
                        }
                    />
                )}
            </div>
        </>
    );
}